import { useParams } from 'react-router-dom';
import useBooking from './hooks/useBooking';

const Booking = () => {
  const { readToken } = useParams();
  const { isLoading, error, booking } = useBooking(readToken);
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  if (!booking) {
    return <div>Booking not found</div>;
  }

  return (
    <div>
      <h1>Booking</h1>
    </div>
  );
};

export default Booking;
